export const ENV = {
    name: 'Development Environments',
    serverURL: 'http://www.seadmdmi.feiradesantana.ba.gov.br/gestao-procon/mobile',
    debug: true,
    production: false,
    web: true
};


// WEBPACK FOOTER //
// ./src/environments/environment.dev.ts